export default "__VITE_ASSET__AHNz3sKW__"